import React, { createContext } from "react";
import {
  IFormContextData,
  IFormContext,
} from "../type/contextType/tkFormContextType";

export const TkFormContext = createContext<{
  formContext: IFormContextData;
  setFormContext: (formContext: IFormContextData) => void;
}>({
  formContext: {},
  setFormContext: (formContext: IFormContextData) => {},
});

export const TkFormContextProvider: React.FC<IFormContext> = (props) => {
  const [formContext, setFormContext] = React.useState<IFormContextData>({});

  return (
    <TkFormContext.Provider value={{ formContext, setFormContext }}>
      {props.children}
    </TkFormContext.Provider>
  );
};

export default TkFormContextProvider;
